import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Card, Form, Input, Button, Alert, Typography 
} from 'antd';
import { 
  UserOutlined, LockOutlined, LoadingOutlined, LoginOutlined 
} from '@ant-design/icons';
import axios from 'axios';

const { Title, Text } = Typography;

function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
        username: values.username,
        password: values.password
      });

      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('username', response.data.user.username);
      localStorage.setItem('userEmail', response.data.user.email);
      localStorage.setItem('userRole', response.data.user.role);
      localStorage.setItem('userAreaId', response.data.user.area_id);
      localStorage.setItem('userAreaName', response.data.user.area_name);
      localStorage.setItem('userFullName', `${response.data.user.first_name} ${response.data.user.last_name}`);
      localStorage.setItem('isCaller', response.data.user.is_caller);
      localStorage.setItem('zoomName', response.data.user.zoom_name);
      localStorage.setItem('senseiName', response.data.user.sensei_name);
      localStorage.setItem('userPhone', response.data.user.phone);

      if (response.data.user.is_caller) {
        navigate(`/caller/${encodeURIComponent(response.data.user.zoom_name)}`);
      } else {
        navigate('/');
      }

    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.error || 'Error en el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      backgroundColor: '#2a2b2b', 
      minHeight: 'calc(100vh - 40px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px'
    }}>
      <Card
        bordered={false}
        style={{
          width: '100%',
          maxWidth: '420px',
          backgroundColor: '#353435',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
        }}
        bodyStyle={{ padding: '32px' }}
      >
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <Title level={2} style={{ color: '#f49b33', marginBottom: '8px' }}>
            <LoginOutlined /> Iniciar Sesión
          </Title>
          <Text type="secondary" style={{ color: '#aaa' }}>
            Ingresa tus credenciales para acceder al panel
          </Text>
        </div>

        {error && (
          <Alert
            message="Error"
            description={error}
            type="error"
            showIcon
            style={{ marginBottom: '24px' }}
          />
        )}

        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Por favor ingresa tu usuario' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Usuario"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Contraseña"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              style={{ backgroundColor: '#f49b33', borderColor: '#f49b33' }}
              icon={loading ? <LoadingOutlined /> : null}
              disabled={loading}
            >
              Iniciar Sesión
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default Login;
